import { InputFormComponent } from "@/modules/shared/components/input-form.component";
import { SelectFormComponent } from "@/modules/shared/components/select-form.component";
import { Form } from "@/modules/shared/components/ui/form";

import { cn } from "@/modules/shared/lib/utils";
import { useOrderFormStore } from "../../stores/order-form.store";
import { ORDER_FORM_PAYMENT } from "./payment.constants";
import { formatDatePaymentFormUtil } from "../../utils/format-date-payment-form.util";
import { type PaymentFormData, usePayment } from "./use-payment.hook";

export function PaymentComponent() {
	const {
		form,
		isViewOrder,
		orderFactorIsLow,
		orderFactorIsFull,
		handleChangeValues,
		formasPagto,
	} = usePayment();


	const { paramsOrderForm } = useOrderFormStore()

	console.log(paramsOrderForm.listaParametroSistema)

	const isDisabledSecondColumn = paramsOrderForm?.listaParametroSistema?.find(item => item.campo === 'FVPrazoUnico')?.valor === "True"
	return (
		<Form {...form}>
			<div className="space-y-4 pb-2">

				{
					formasPagto?.length > 0 ? (
						<SelectFormComponent<PaymentFormData>
							control={form.control}
							name="fkCondPagto"
							label="Tipo pagamento"
							options={
								(formasPagto?.map((item) => {
									return {
										value: item.idFormaPagto.toString(),
										label: item.descricao,
									};
								}))
							}
							onChange={(value) => {
								if (formasPagto && formasPagto?.length > 0) {
									handleChangeValues("fkCondPagto", value);
									return;
								}
								handleChangeValues("formaPagto", value);
							}}
							disabled={isViewOrder}
						/>
					) : (
						<SelectFormComponent<PaymentFormData>
							control={form.control}
							name="formaPagto"
							label="Tipo pagamento"
							options={
								([
									{
										value: "BOLETO",
										label: "BOLETO",
									},
									{
										value: "CHEQUE",
										label: "CHEQUE",
									},
									{
										value: "A VISTA",
										label: "A VISTA",
									},
								])
							}
							onChange={(value) => {
								if (formasPagto && formasPagto?.length > 0) {
									handleChangeValues("fkCondPagto", value);
									return;
								}
								handleChangeValues("formaPagto", value);
							}}
							disabled={isViewOrder}
						/>
					)
				}


				<div className="flex flex-1 gap-2">
					<div className={cn("flex flex-col flex-1 space-y-2", isDisabledSecondColumn && "grid grid-cols-2 gap-2 ")}>
						<>
							{ORDER_FORM_PAYMENT.column1.map((item) => (
								<InputFormComponent<PaymentFormData>
									key={item.id}
									control={form.control}
									name={item.register}
									label={item.text}
									type="number"
									min={1}
									max={999}
									tabIndex={item.indexField}
									disabled={isViewOrder}
									readOnly={orderFactorIsLow}
									onKeyUp={(e) => {
										if (e.key === "Enter") {
											const nextIndex = item.indexField + 1;
											const nextInput = document.querySelector(
												`[tabindex="${nextIndex}"]`,
											) as HTMLInputElement;
											if (nextInput) {
												nextInput.focus();
											}
										}
									}}
									onChangeValue={(e) => {
										const value = formatDatePaymentFormUtil(e);
										e.currentTarget.value = value;
										handleChangeValues(item.fieldInJson, value);
									}}
								/>
							))}
						</>
					</div>

					{!isDisabledSecondColumn && (
						<div className="flex flex-col flex-1 space-y-2">

							<>
								{ORDER_FORM_PAYMENT.column2.map((item) => (
									<InputFormComponent<PaymentFormData>
										key={item.id}
										control={form.control}
										name={item.register}
										label={item.text}
										type="number"
										tabIndex={item.indexField}
										min={1}
										max={999}
										disabled={isViewOrder}
										readOnly={orderFactorIsFull}
										onKeyUp={(e) => {
											e.preventDefault();
											const value = formatDatePaymentFormUtil(e);
											handleChangeValues(item.fieldInJson, value);
											if (e.key === "Enter") {
												const nextIndex = item.indexField + 1;
												const nextInput = document.querySelector(
													`[tabindex="${nextIndex}"]`,
												) as HTMLInputElement;
												if (nextInput) {
													nextInput.focus();
												}
											}
										}}
										onChangeValue={(e) => {
											const value = formatDatePaymentFormUtil(e);
											e.currentTarget.value = value;
											handleChangeValues(item.fieldInJson, value);
										}}
									/>
								))}
							</>
						</div>
					)}
				</div>
			</div>
		</Form>
	);
}
